// extracted by mini-css-extract-plugin
export default {"tickerCell":"TickerCell_tickerCell__v3CTh","tickerCellValue":"TickerCell_tickerCellValue__vIDOv"};